import { render, staticRenderFns } from "./AccountDetailsView.vue?vue&type=template&id=674be750&"
import script from "./AccountDetailsView.vue?vue&type=script&lang=js&"
export * from "./AccountDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetailsView.vue?vue&type=style&index=0&id=674be750&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports